import React from 'react'

import styles from './TableHeaderButton.module.scss'

interface TableHeaderButtonProps {
  label?: string
  icon?: JSX.Element
  onClick: () => void
  'data-testid': string
}

const TableHeaderButton: React.FC<TableHeaderButtonProps> = ({ label, onClick, 'data-testid': dataTestId, icon }) => {
  return (
    <button type="button" className={styles['table-header-button']} onClick={onClick} data-testid={dataTestId}>
      {label || icon}
    </button>
  )
}

export default TableHeaderButton
